<template>
  <div>
    <div class="d-flex">
      <h4>Colunas</h4>
      <b-button
        @click="addColuna"
        size="sm"
        variant="info"
        class="ml-auto mb-3 rounded-pill"
      >
        <font-awesome-icon icon="plus-circle" />
        Adicionar coluna
      </b-button>
    </div>

    <b-table-simple hover small caption-top responsive class="table-config">
      <b-thead>
        <b-tr>
          <b-th v-for="n in num_columns" :key="'head-' + n">
            {{ (n - 1) | letra }}
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td v-for="n in num_columns" :key="'col-' + n">
            <b-select v-model="config[n - 1]" :options="options" size="sm" />
          </b-td>

          <b-td />
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  data: () => ({
    config: [],
    options: [
      { value: "codigo", text: "Código" },
      { value: "emenda", text: "Emenda " },
      { value: "parlamentar", text: "Parlamentar" },
      { value: "cnpj", text: "CNPJ" },
      { value: "beneficiario", text: "Beneficiário" },
      { value: "repasse", text: "Valor do Repasse" },
      { value: "", text: "Ignorar" },
    ],
  }),
  computed: {
    num_columns() {
      return this.config.length;
    },
  },
  watch: {
    config() {
      this.$emit("input", this.config);
    },
  },
  methods: {
    addColuna() {
      this.config.push("");
    },
  },
  mounted() {
    this.config = [
      "codigo",
      "emenda",
      "parlamentar",
      "cnpj",
      "beneficiario",
      "repasse",
    ];
  },
};
</script>

<style lang="scss">
.table-config {
  padding-bottom: 1rem;
  th {
    text-align: center;
    background: #e7e7e7;
    color: #616262;
    font-size: 0.8rem !important;
    text-transform: uppercase;
    color: #666;
    border: none !important;
    padding: 0.2rem !important;

    width: 130px;
    min-width: 130px;
    max-width: 130px;
  }

  td {
    padding: 0px !important;

    select {
      padding: 0px;
    }
  }
}
</style>
